module.exports = __webpack_public_path__ + "img/img1.fced7166.svg";